import { Box, Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { SkeletonCard } from "components/skeleton/SkeletonCard"
import { apiEndpoints } from "generated/apiEndpoints"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import ExamOverviewCard from "./components/ExamOverviewCard"
import { examOverviewIcons, examOverviewName } from "./helpers/examOverview"

const AdminLearning = () => {
  const { t } = useTranslation("translation")
  const prefix = "learning.admin"

  const loadingContext = React.useContext(GlobalLoaderContext)

  const [examSummaries, examSummariesFuncs] = useApi()

  const [exams, setExams] = useState([])

  React.useEffect(() => {
    examSummariesFuncs.get(apiEndpoints.learningadmin.getexamsummaries)
    // examResultsFuncs.get(apiEndpoints.learningadmin.getexamresultsshortlist.replace("{limit}", 8))
  }, [examSummariesFuncs])

  React.useEffect(() => {
    loadingContext.setLoading(examSummaries.status === 1)
  })

  React.useEffect(() => {
    if (examSummaries.status === 2) {
      setExams(examSummaries.data)
    }
  })

  return (
    <div>
      <Container>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" mb={5}>
          <Box>
            <Typography variant="h1">{t(`${prefix}.titles.courses`, "Education")}</Typography>
            <Typography variant="paragraphLarge">
              {t(
                `${prefix}.overview.manage_courses`,
                "From here you can manage training courses, add users and send reminders."
              )}
            </Typography>
          </Box>
        </Grid>
        <Box>
          <Grid container spacing={3} display="flex" sx={{ flexDirection: { xs: "column", md: "row" } }}>
            {examSummaries.status === 2 && exams.length > 0 ? (
              exams.map((item) => {
                return (
                  <Grid item xs={12} md={6} xl={4}>
                    <ExamOverviewCard
                      key={item.id}
                      id={item.id}
                      examinationName={examOverviewName(item.examinationName)}
                      attendeesCount={`${item.attendeesCount} ${t(`${prefix}.overview.participants`, "participants")}`}
                      passedCount={
                        examSummaries.status === 1 ? null : `${item.passedCount} ${t("global.of", "of")} ${item.attendeesCount}`
                      }
                      expiresIn30Days={examSummaries.status === 1 ? null : item.expiresIn30Days}
                      expiredCount={examSummaries.status === 1 ? null : item.expired}
                      subtitle1={t(`${prefix}.overview.approved`, "Approved")}
                      subtitle2={t(`${prefix}.overview.days_left`, "Expires in 30 days")}
                      subtitle3={t(`${prefix}.overview.expired`, "Expired")}
                      icon={examOverviewIcons(item.id)}
                    />
                  </Grid>
                )
              })
            ) : (
              <>
                <Grid mt={3} item xs={12} md={6} xl={4}>
                  <SkeletonCard sx={{ py: 4 }} />
                </Grid>
                <Grid mt={3} item xs={12} md={6} xl={4}>
                  <SkeletonCard sx={{ py: 4 }} />
                </Grid>
                <Grid mt={3} item xs={12} md={6} xl={4}>
                  <SkeletonCard sx={{ py: 4 }} />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Container>
    </div>
  )
}
export default AdminLearning
